import { render, staticRenderFns } from "./UCIrvineQuiz1S1Q8.vue?vue&type=template&id=24c09a8c&"
import script from "./UCIrvineQuiz1S1Q8.vue?vue&type=script&lang=js&"
export * from "./UCIrvineQuiz1S1Q8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VContainer,VRadio,VRadioGroup})
